import { render, staticRenderFns } from "./imageCarousel.vue?vue&type=template&id=881ff1aa&"
import script from "./imageCarousel.vue?vue&type=script&lang=js&"
export * from "./imageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('881ff1aa')) {
      api.createRecord('881ff1aa', component.options)
    } else {
      api.reload('881ff1aa', component.options)
    }
    module.hot.accept("./imageCarousel.vue?vue&type=template&id=881ff1aa&", function () {
      api.rerender('881ff1aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2u77omFMFc92s/JS/imageCarousel.vue"
export default component.exports